import React, { } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Container from '@material-ui/core/Container';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import 'react-toastify/dist/ReactToastify.css';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import Grid from '@material-ui/core/Grid';
import CloseIcon from '@material-ui/icons/Close';
import CircularProgress from '@material-ui/core/CircularProgress';
import { dateFormatMoment } from '../../../util/DateUtil';
import { ptBR } from "date-fns/locale";

const useStyles = makeStyles(theme => ({
    paper: {
        marginTop: '20px',
        display: 'flex',
        flexDirection: 'column',

    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    title: {
        flex: '1 1 100%',
        paddingTop: '20px;'
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    closeIcon: {
        marginTop: '20px',
        marginBottom: '20px',
        cursor: 'pointer'
    },
    loading: {
        marginRight: '10px',
        marginLeft: '10px'
    }
}));

export default function ObservacaoAlunoFormV2({ observacaoAluno, setObservacaoAluno, clickSubmit, isLoadingSave }) {
    const classes = useStyles();

    const handleChange = (event) => {
        setObservacaoAluno({
            ...observacaoAluno,
            [event.target.name]: event.target.value
        })
    }

    const handleDataChange = (data) => {
        if (data)
            data.setHours(0, 0, 0, 0);

        setObservacaoAluno({
            ...observacaoAluno,
            data: data
        })
    }




    return (
        <div>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
                        <Container className={classes.paper} component={Paper} maxWidth="sm">
                            <CloseIcon
                                onClick={() => setObservacaoAluno(null)}
                                className={classes.closeIcon}
                                fontSize='small'
                            />
                            <form onSubmit={clickSubmit}>
                                <KeyboardDatePicker
                                    fullWidth
                                    required
                                    disableToolbar
                                    variant="outlined"
                                    format="dd/MM/yyyy"
                                    margin="normal"
                                    label="Data"
                                    value={observacaoAluno && observacaoAluno.data ? dateFormatMoment(observacaoAluno.data) : null}
                                    onChange={handleDataChange}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                />
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    size='small'
                                    multiline
                                    rows="4"
                                    inputProps={{ maxLength: 2000 }}
                                    fullWidth
                                    label="Conteúdo"
                                    name="conteudo"
                                    onChange={handleChange}
                                    value={observacaoAluno && observacaoAluno.conteudo ? observacaoAluno.conteudo : ''}
                                />
                                <Button
                                    type="submit"
                                    disabled={isLoadingSave}
                                    variant="contained"
                                    color="primary"
                                    className={classes.submit}>
                                    {isLoadingSave && <CircularProgress className={classes.loading} color="primary" size={20} />}
                                    Salvar
                                </Button>
                            </form>
                        </Container>
                    </MuiPickersUtilsProvider>
                </Grid>
            </Grid>

        </div>
    );
}